<template lang="html">
  <div
    class="charge-history"
    v-if="isAdmin">
    <div class="card">
      <div class="card-header">
        <h3 class="text-nowrap">Histórico de recargas</h3>
        <div class="w-100">
          <font
            class="float-right"
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
      <div class="card-body">
        <div
          v-if="error"
          class="alert alert-danger"
          role="alert">
          <span v-html="error.message" />
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 d-flex">
            <div class="input-group">
              <div class="input-group-prepend">
                <button
                  disabled
                  class="input-group-text">por página</button>
              </div>
              <select
                class="custom-select custom-select-sm form-control form-control-sm perPage"
                id="perPage"
                v-model="perPage">
                <option
                  v-for="option in pageOptions"
                  :key="option"
                  :value="option">
                  {{ option }}
                </option>
              </select>
            </div>
            <div class="ml-auto">
              <charge-new slider-name="chargeAmountSliderHistoryCharge" />
            </div>
          </div>
          <div class="col-sm-12 col-md-6 d-flex">
            <div class="input-group filter ml-auto">
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Buscar por"
                aria-label="Buscar por"
                v-model="filter">
              <div class="input-group-append">
                <button
                  :disabled="!filter"
                  @click="filter = ''"
                  class="input-group-text">Limpar</button>
              </div>
            </div>
          </div>
        </div>
        <div class="card-table text-left">
          <b-table
            class="table"
            show-empty
            striped
            hover
            small
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered">
            <template
              slot="paymentActions"
              slot-scope="row">
              <div v-if="row.item && row.item.paymentLink">
                <a
                  class="link"
                  :href="row.item.paymentLink"
                  target="_blank"
                  v-if="showPaymentAction(row.item)">
                  {{ paymentAction(row.item) }}
                </a>
                <span v-if="showInvoiceLink(row.item)">
                  | <a
                    class="link"
                    :href="row.item.invoiceLink"
                    target="_blank">
                    Nota Fiscal
                  </a>
                </span>
                <span v-if="showPaymentCancel(row.item)">
                  | <a
                    class="link"
                    href="#"
                    @click.prevent="openCancelPaymentModal(row.item.id)">
                    Cancelar Pagamento
                  </a>
                </span>
              </div>
            </template>
            <template
              slot="type"
              slot-scope="row">
              <span :title="row.item.description">{{ row.item.type }}</span>
            </template>
          </b-table>
        </div>
        <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          :limit="10" />
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="cancelPaymentModal"
      ref="cancelPaymentModal"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover esta recarga?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="cancelPayment">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="tutorialCharge"
      ref="tutorialCharge"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Tutorial Adicionar Recarga</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <iframe
              width="760"
              height="420"
              src="https://www.youtube.com/embed/hJj69DraVrU"
              title="Tutorial Adicionar Recarga"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import ChargeNew from '@/components/Charge/New.vue'
import { EventBus } from '@/services/event-bus'

const PAYMENT_METHODS_TRANSLATE = {
  'UNDEFINED': '',
  'PAYPAL': 'PayPal',
  'CREDIT_CARD': 'Cartão de Crédito',
  'DEBIT_CARD': 'Cartão de Débito',
  'BOLETO': 'Boleto',
  'PIX': 'PIX',
  'LINK': 'Link'
}

const STATUS_TRANSLATE = {
  'PENDING': 'Aguardando Pagamento',
  'PAID': 'Pago',
  'OVERDUE': 'Vencido',
  'REFUNDED': 'Estornado',
  'CANCELED': 'Cancelado',
  'CONFIRMED_MANUALLY': 'Confirmado (conciliação)',
  'PROCESSING': 'Processando'
}

const CHARGE_TYPES_TRANSLATE = {
  'CREDIT': 'Recarga',
  'MANUAL': 'Solicitação via Suporte',
  'SUBSCRIPTION': 'Mensalidade',
  'AUTOMATIC': 'Recarga Automática'
}

export default {
  name: 'ChargeHistory',
  components: {
    ChargeNew
  },
  data () {
    return {
      error: null,
      perPage: 10,
      pageOptions: [10, 25, 50],
      currentPage: 1,
      totalRows: 1,
      filter: null,
      fields: {
        id: {
          label: '#',
          sortable: true
        },
        type: {
          label: 'Tipo',
          sortable: true
        },
        paymentMethod: {
          label: 'Método de Pagamento',
          sortable: false
        },
        dueDate: {
          label: 'Vencimento',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return this.parseDate(value)
          }
        },
        totalAmount: {
          label: 'Valor',
          sortable: false,
          sortByFormatted: false,
          filterByFormatted: false,
          formatter: (value) => {
            return value ? `R$ ${this.parseAmount(value)}` : ''
          }
        },
        status: {
          label: 'Status',
          sortable: false
        },
        paidAt: {
          label: 'Paga em',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return this.parseDate(value)
          }
        },
        createdAt: {
          label: 'Criada em',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return this.parseDateTime(value)
          }
        },
        paymentActions: {
          label: 'Ações',
          sortable: false
        }
      },
      items: null,
      deleteChargeId: null
    }
  },
  mounted () {
    this.getChargeHistory()
    EventBus.$on('reload-charge-history', amount => {
      if (amount && parseFloat(amount) > 0) {
        this.getChargeHistory()
      }
    })
  },
  methods: {
    getChargeHistory () {
      this.error = null
      loopback
        .get(`/charges?page=1&filter[order]=createdAt%20DESC`)
        .then(charges => {
          if (charges) {
            this.items = charges.data
              .map(f => {
                f.amount = this.formatPrice(f.amount)
                f.type = CHARGE_TYPES_TRANSLATE[f.type]
                f.paymentMethod = PAYMENT_METHODS_TRANSLATE[f.paymentMethod]
                f.status = STATUS_TRANSLATE[f.status]
                return f
              })
            this.totalRows = this.items.length
          }
        })
        .catch((err) => {
          this.error = err
        })
    },
    openCancelPaymentModal (id) {
      this.deleteChargeId = id
      $(this.$refs.cancelPaymentModal).modal('show')
    },
    cancelPayment () {
      loopback
        .patch(`/charges/${this.deleteChargeId}/cancel`)
        .then(() => {
          this.deleteChargeId = null
          this.getChargeHistory()
          $(this.$refs.cancelPaymentModal).modal('hide')
        })
        .catch((err) => {
          if (err && err.message === `charge id ${this.deleteChargeId} cannot be canceled`) {
            this.error = { message: `A recarga ID ${this.deleteChargeId} não pode ser cancelada` }
          } else {
            this.error = err
          }
          this.deleteChargeId = null
          $(this.$refs.cancelPaymentModal).modal('hide')
        })
    },
    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openTutorial () {
      $(this.$refs.tutorialCharge).modal('show')
    },
    paymentAction (charge) {
      if (['Aguardando Pagamento'].includes(charge.status)) {
        return 'Pagar'
      } else {
        return 'Ver Detalhes'
      }
    },
    showPaymentAction (charge) {
      return charge.status !== 'Confirmado (conciliação)'
    },
    showInvoiceLink (charge) {
      return charge && charge.invoiceLink
    },
    showPaymentCancel (charge) {
      return charge.type === 'Recarga' && charge.status === 'Aguardando Pagamento'
    },
    parseDate (date) {
      if (date) return new Date(date).toLocaleDateString('pt-BR', { timeZone: 'UTC', hour12: false })
      return ''
    },
    parseDateTime (date) {
      if (date) return new Date(date).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', hour12: false })
      return ''
    },
    parseAmount (amount) {
      const amountParsed = parseFloat(amount)
      if (isNaN(amountParsed)) {
        return amount
      }
      return amountParsed.toFixed(2).replace('.', ',')
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Charge/History.vue